import PortalLayout from "../../admin-shared/PortalLayout";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Breadcrumb from "../components/Breadcrumb";
import StoreLocationCaptureModal from "../components/StoreLocationCaptureModal";
import useTrialExp from "../components/useTrialExp";

const Layout = (props) => {
  const { Popup } = useTrialExp();
  return (
    <PortalLayout
      {...props}
      portalId="executive"
      Sidebar={Sidebar}
      Header={Header}
      Breadcrumb={Breadcrumb}
      TrialPopup={Popup}
      StoreLocationCaptureModal={StoreLocationCaptureModal}
    />
  );
};

export default Layout;
